export default __webpack_public_path__ + "static/media/36I-102798_-15973_0.bf197884.jpg";